import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDWbzG_Aor26V6Hvq-N7VoDEp7ItoUCyeM",
  authDomain: "mamaket-2.firebaseapp.com",
  projectId: "mamaket-2",
  storageBucket: "mamaket-2.firebasestorage.app",
  messagingSenderId: "600799879933",
  appId: "1:600799879933:web:01117c3e0b3d0b56659494"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export { messaging };